/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_3Inputs */

const en_live_caption_youtube_region_3 = /** @type {(inputs: Live_Caption_Youtube_Region_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top right`)
};

const fr_live_caption_youtube_region_3 = /** @type {(inputs: Live_Caption_Youtube_Region_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En haut à droite`)
};

const de_live_caption_youtube_region_3 = /** @type {(inputs: Live_Caption_Youtube_Region_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oben rechts`)
};

const it_live_caption_youtube_region_3 = /** @type {(inputs: Live_Caption_Youtube_Region_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In alto a destra`)
};

const ru_live_caption_youtube_region_3 = /** @type {(inputs: Live_Caption_Youtube_Region_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вверху справа`)
};

const es_live_caption_youtube_region_3 = /** @type {(inputs: Live_Caption_Youtube_Region_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arriba a la derecha`)
};

const zh_cn2_live_caption_youtube_region_3 = /** @type {(inputs: Live_Caption_Youtube_Region_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右上角`)
};

const ja_live_caption_youtube_region_3 = /** @type {(inputs: Live_Caption_Youtube_Region_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右上`)
};

const hi_live_caption_youtube_region_3 = /** @type {(inputs: Live_Caption_Youtube_Region_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठीक तरह से ऊपर`)
};

const pt_pt2_live_caption_youtube_region_3 = /** @type {(inputs: Live_Caption_Youtube_Region_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canto superior direito`)
};

/**
* | output |
* | --- |
* | "Top right" |
*
* @param {Live_Caption_Youtube_Region_3Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_3 = /** @type {((inputs?: Live_Caption_Youtube_Region_3Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_3Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_youtube_region_3(inputs)
	if (locale === "de") return de_live_caption_youtube_region_3(inputs)
	if (locale === "it") return it_live_caption_youtube_region_3(inputs)
	if (locale === "ru") return ru_live_caption_youtube_region_3(inputs)
	if (locale === "es") return es_live_caption_youtube_region_3(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_youtube_region_3(inputs)
	if (locale === "ja") return ja_live_caption_youtube_region_3(inputs)
	if (locale === "hi") return hi_live_caption_youtube_region_3(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_youtube_region_3(inputs)
	return en_live_caption_youtube_region_3(inputs)
});